<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">批量导入一件代发</span>
    </div>
    <div v-if="!show_success" class="mt50">
      <Form :model="formItem" :label-width="130">
        <FormItem label="导入批次">
          <span class="ml10">{{post_batch_no}}</span>
          <!-- <input class="w300 ivu-input ivu-input-default" v-model="formItem.client_code" /> -->
        </FormItem>
        <FormItem label="选择文件" style="margin-bottom: 5px;">
          <input class="w300 ivu-input ivu-input-default" v-model="selectTxt" />
          <button class="ivu-btn ivu-btn-primary" @click="triggerFile">浏览文件</button>
        </FormItem>
        <FormItem label="">
          <a @click="download" class="blue">下载Excel模板文件</a>
        </FormItem>
        <FormItem label="">
          <button class="ivu-btn ivu-btn-primary" @click="upData">上传文件</button>
        </FormItem>
      </Form>
    </div>

    <div v-if="show_success" class="export-success mt50">
      <p class="mt20">以下为导入结果：</p>
      <Table class="mt20" border :columns="columns" :data="list">
      </Table>
      <div class="mt30 tr">
        <button v-if="!had_error" class="ivu-btn ivu-btn-primary" @click="confirmUp">
          确定创建发货单
        </button>
        <button class="ivu-btn ivu-btn-primary" @click="show_success=false">重新上传</button>
      </div>
    </div>

    <form id="uploadForm" style="display: none;">
      <input type="file" id="file" @change="uploadFile">
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
         post_batch_no: '',
        client_name_code: '',
        client_code: '',
        import_id: '',
        list: [],
        columns: [{
          title: '收件人',
          key: 's_user_name',
          tooltip: true,
          width: 200,
        }, {
          title: '收件人电话',
          key: 's_user_phone',
          tooltip: true,
          width: 200,
        }, {
          title: '地址',
          key: 's_address1',
          tooltip: true,
          width: 200,
          render: (h, params) => {
            let txt = params.row.s_address1;
            if(params.row.s_address1){
              txt += ' ' + params.row.s_address2;
            }

            txt += ' ' + params.row.s_city + ' ' + params.row.s_state + ' ' + params.row.s_postcode


            return h('span', txt);
          }
        }, {
          title: '快递方式',
          key: 'post_type',
          tooltip: true,
          width: 100,
          render: (h, params) => {
            let post_type = params.row.post_type;
            let txt = '-';
            if (post_type == 0) {
              txt = 'USPS'
            }
            if (post_type == 1) {
              txt = 'UPS'
            }
            return h('span', txt)
          }
        }, {
          title: '商品',
          key: 'sku_details',
          tooltip: true,
          width: 250,
        }, {
          title: '导入结果',
          tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: {
                cursor: "pointer",
                color: params.row.import_success ? "green" : 'red'
              },
            }, params.row.import_success ? '成功' : params.row.error_message)
          }
        }],
        formItem: {},
        fileData: '',
        selectTxt: '',
        show_success: false,
        had_error: false, //是否有错误
        total_import_count: 0
      }
    },
    methods: {
      triggerFile() {
        $('#file').trigger('click')
      },
      download() {
        this.$axios.get("/WarehousePost/import/excel/template").then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      uploadFile(event) { //上传文件
        let _file = event.target.files[0];
        this.fileData = _file;
        this.selectTxt = _file.name;
      },
      upData() { //确定上传
        if (!this.selectTxt) {
          this.$Message.error('请上传文件');
          return
        }
        let formData = new FormData();
        formData.append('file', this.fileData);
        this.$axios.post('/WarehousePost/post/import?post_batch_no=' + this.post_batch_no, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((data) => {

            this.had_error = false;
          if (data.success) {
            this.$Message.success("上传成功");
            this.fileData = "";
            this.selectTxt = "";
            this.show_success = true;
            this.list = data.data;

            this.total_import_count = data.data.length;

            if (data.data && data.data.length) {
              data.data.forEach(item => {
                if (!item.import_success) {
                  this.had_error = true
                }
              })
            }
            document.getElementById("uploadForm") && document.getElementById("uploadForm").reset(); //清除input
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      confirmUp() {
        this.$axios.post('/WarehousePost/post/import/confirm?post_batch_no=' + this.post_batch_no).then((data) => {
          if (data.success) {
            this.$router.push({
              path: '/One/OneList?post_batch_no='+this.post_batch_no+'&total_count='+this.total_import_count
            })
            this.$Message.success('创建成功');
          }
        })
      },
      reupload() {
        window.location.reload()
      }
    },
    created() {
      this.post_batch_no = this.$route.query.post_batch_no;
      // this.client_name_code = localStorage.getItem('client_name_code') || ''
      // this.client_code = localStorage.getItem('client_code') || ''
      // if (!this.client_code) {
      //   this.$Message.info('请选择子账户');
      // }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/one/import.vue